'use client';
import { useEffect } from 'react';

type Props = {
  cannonicalUrl: String;
};

/**
 * https://github.com/moving-content/pf-website/issues/992
 **/
export function Outbrain(props: Props) {
  useEffect(() => {
    const { OBR } = window;
    if (
      OBR &&
      OBR.extern &&
      typeof OBR.extern.renderSpaWidgets === 'function'
    ) {
      OBR.extern.renderSpaWidgets(props.cannonicalUrl);
    }
  });

  return (
    <>
      <div
        className="OUTBRAIN p-5"
        data-src={props.cannonicalUrl}
        data-widget-id="AR_1"
      />
    </>
  );
}
